/** 登录 */
// 是否登录
export const LOGIN_IS_LOGIN = '/cmms/auth/isLogin';
// 登录
export const LOGIN_LOGINING = '/cmms/auth/login';
// 退出登录
export const LOGIN_LOGOUT = '/cmms/auth/logout';
// MIP登录获取code
export const LOGIN_GETCODE = '/cmms/auth/getCode';
